var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCertificateBorderMiddleBronze(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1600.2 349.2",
    style: {
      enableBackground: "new 0 0 1600.2 349.2"
    },
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.6;fill:#8C5E35;enable-background:new    ;}\n\t.st1{opacity:0.3;fill:#FFFFFF;enable-background:new    ;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "72.9,701.5 53.5,721.5 34.2,701.5 34.2,-224.2 53.5,-244.2 72.9,-224.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "53.5,721.5 72.9,701.5 72.9,-224.2 53.5,-244.2  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1527.3,-224.2 1546.8,-244.2 1566.1,-224.2 1566.1,701.5 1546.8,721.5 1527.3,701.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "1546.8,-244.2 1527.3,-224.2 1527.3,701.5 1546.8,721.5  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificateBorderMiddleBronze);
export default __webpack_public_path__ + "static/media/certificate-border-middle-bronze.fe9a27238621d00da43ca27c71626d56.svg";
export { ForwardRef as ReactComponent };